<div class="container">
  <mat-card>
    <form [formGroup]="groupForm">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.name' | translate }}</mat-label>
            <input matInput required formControlName="name" />
            @if (groupForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Group Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
            @if (groupForm.controls.name.hasError('pattern')) {
              <mat-error>
                {{ 'labels.inputs.Group Name' | translate }} <strong>{{ 'labels.inputs.cannot' | translate }}</strong>
                {{ 'labels.commons.begin with a special character or number' | translate }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Office' | translate }}</mat-label>
            <mat-select required formControlName="officeId">
              @for (office of officeData; track office) {
                <mat-option [value]="office.id">
                  {{ office.name }}
                </mat-option>
              }
            </mat-select>
            @if (groupForm.controls.officeId.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Office' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Staff' | translate }}</mat-label>
            <mat-select formControlName="staffId">
              @for (staff of staffData; track staff) {
                <mat-option [value]="staff.id">
                  {{ staff.displayName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field (click)="submittedOnDatePicker.open()">
            <mat-label>{{ 'labels.inputs.Submitted On' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="submittedOnDatePicker"
              required
              formControlName="submittedOnDate"
            />
            <mat-datepicker-toggle matSuffix [for]="submittedOnDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #submittedOnDatePicker></mat-datepicker>
            @if (groupForm.controls.submittedOnDate.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Submission Date' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-checkbox labelPosition="before" formControlName="active">
            {{ 'labels.inputs.Active' | translate }}
          </mat-checkbox>

          @if (groupForm.controls.active.value) {
            <mat-form-field (click)="activationDatePicker.open()">
              <mat-label>{{ 'labels.inputs.Activation Date' | translate }}</mat-label>
              <input
                matInput
                [min]="groupForm.value.submittedOnDate"
                [max]="maxDate"
                [matDatepicker]="activationDatePicker"
                required
                formControlName="activationDate"
              />
              <mat-datepicker-toggle matSuffix [for]="activationDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #activationDatePicker></mat-datepicker>
              @if (groupForm.controls.activationDate.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Activation Date' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
          }

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.External id' | translate }}</mat-label>
            <input matInput formControlName="externalId" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Add Clients' | translate }}</mat-label>
            <input matInput [formControl]="clientChoice" [matAutocomplete]="clientsAutocomplete" />
          </mat-form-field>
        </div>

        <mat-autocomplete autoActiveFirstOption #clientsAutocomplete="matAutocomplete" [displayWith]="displayClient">
          @for (client of clientsData; track client) {
            <mat-option [value]="client">
              {{ client.displayName }}
            </mat-option>
          }
        </mat-autocomplete>

        <div class="layout-row">
          @if (clientChoice.value) {
            <div class="mat-table">
              <div class="mat-header-row">
                <div class="mat-header-cell">{{ 'labels.inputs.Client Details' | translate }}</div>
                <button mat-icon-button (click)="addClient()">
                  <fa-icon icon="plus"></fa-icon>
                </button>
              </div>
              <div class="mat-row">
                <div class="mat-cell">{{ 'labels.inputs.name' | translate }}</div>
                <div class="mat-cell">{{ clientChoice.value.displayName }}</div>
              </div>
              <div class="mat-row">
                <div class="mat-cell">{{ 'labels.inputs.Id' | translate }}</div>
                <div class="mat-cell">{{ clientChoice.value.id }}</div>
              </div>
              <div class="mat-row">
                <div class="mat-cell">{{ 'labels.inputs.Office' | translate }}</div>
                <div class="mat-cell">{{ clientChoice.value.officeName }}</div>
              </div>
            </div>
          }

          @if (clientMembers.length) {
            <mat-nav-list>
              <h3 matSubheader>{{ 'labels.heading.Selected Clients' | translate }}</h3>
              @for (client of clientMembers; track client; let i = $index) {
                <div mat-list-item>
                  <span matLine>{{ client.displayName }}</span>
                  <button mat-icon-button color="warn" (click)="removeClient(i)">
                    <fa-icon icon="trash"></fa-icon>
                  </button>
                </div>
              }
            </mat-nav-list>
          }
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!groupForm.valid" (click)="submit()">
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
